import "../Styles/Pages/Sponsor.css"
import SectionOneS from "../Components/Sponsor/SectionOneS";
import SponsorS from "../Components/Sponsor/SponsorS";

const Sponsor = () => {
    return ( 
        <div className="sponsor">
            <SectionOneS />
            <SponsorS />
        </div>
     );
}
 
export default Sponsor;